import React, { useState } from 'react';
import { useOrders } from '../contexts/OrderContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Card } from '../components/ui/Card';
import { PackageCheck } from 'lucide-react';
export function StorageAssignmentPage() {
  const {
    getOrdersByStatus,
    updateOrderStatus,
    assignStorage
  } = useOrders();
  const [selectedOrderId, setSelectedOrderId] = useState('');
  const [zone, setZone] = useState('');
  const [shelf, setShelf] = useState('');
  const readyOrders = getOrdersByStatus('NETTOYAGE_TERMINE');
  const handleAssign = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedOrderId || !zone || !shelf) return;
    try {
      await assignStorage(selectedOrderId, zone, shelf);
      await updateOrderStatus(selectedOrderId, 'STOCKEE_LIVRAISON', `Stocké en ${zone}-${shelf}`);
      // Reset form
      setSelectedOrderId('');
      setZone('');
      setShelf('');
      alert('Stockage assigné avec succès');
    } catch (err) {
      alert("Erreur lors de l'assignation");
    }
  };
  return <div className="max-w-xl mx-auto space-y-6" data-id="element-628">
      <h1 className="text-2xl font-bold text-gray-900" data-id="element-629">
        Stockage pour Livraison
      </h1>

      <Card data-id="element-630">
        <form onSubmit={handleAssign} className="space-y-6" data-id="element-631">
          <Select label="Commande à stocker" value={selectedOrderId} onChange={e => setSelectedOrderId(e.target.value)} options={readyOrders.map(o => ({
          value: o.id,
          label: `${o.id} - ${o.clientName} (${o.quantity} ${o.type})`
        }))} required data-id="element-632" />

          <div className="grid grid-cols-2 gap-4" data-id="element-633">
            <Input label="Zone de Stockage" value={zone} onChange={e => setZone(e.target.value)} placeholder="ex: A, B, C" required data-id="element-634" />
            <Input label="Étagère / Rack" value={shelf} onChange={e => setShelf(e.target.value)} placeholder="ex: R1, E2" required data-id="element-635" />
          </div>

          <Button type="submit" fullWidth disabled={!selectedOrderId || !zone || !shelf} leftIcon={<PackageCheck className="w-4 h-4" data-id="element-637" />} data-id="element-636">
            Valider Stockage
          </Button>
        </form>
      </Card>

      <div className="mt-8" data-id="element-638">
        <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-639">
          En attente de stockage ({readyOrders.length})
        </h3>
        {readyOrders.length === 0 ? <p className="text-gray-500 text-sm" data-id="element-640">Tout est rangé !</p> : <ul className="bg-white rounded-lg shadow divide-y divide-gray-100" data-id="element-641">
            {readyOrders.map(order => <li key={order.id} className="p-4 text-sm" data-id="element-642">
                <span className="font-bold text-gray-900" data-id="element-643">{order.id}</span>
                <span className="mx-2 text-gray-300" data-id="element-644">|</span>
                <span className="text-gray-600" data-id="element-645">{order.clientName}</span>
                <span className="float-right text-gray-400" data-id="element-646">
                  {new Date(order.updatedAt).toLocaleDateString()}
                </span>
              </li>)}
          </ul>}
      </div>
    </div>;
}